import { format } from 'date-fns'
import React from 'react'

import { useLogisticFilters } from 'hooks/useLogisticFilters'
import { useStores } from 'hooks/useStores'
import { logisticApi } from 'redux/services/logistic'
import { LogisticShortObject } from 'redux/services/logistic/types'

import { AppLayout } from 'components/AppLayout'
import { AppLayoutTable } from 'components/AppLayoutTable'
import { AppLoader } from 'components/AppLoader'
import { AppPagination } from 'components/AppPagination'
import { AppTable } from 'components/AppTable'

import { LOGISTIC_STATUS_TEXT } from 'constants/logistic'
import { UserRole } from 'models/user'

import { ReactComponent as UserCircleAddIcon } from 'assets/images/svg/user_circle_add.svg'

import { CreateLogisticModal } from './components/Create'
import { Details } from './components/Details'
import { EmptyDetails } from './components/EmptyDetails'
import { Filters } from './components/Filters'
import { Statistics } from './components/Statistics'

enum ModalState {
  None,
  Create,
}

export const NewCartsPage = () => {
  const { userStore } = useStores()
  const { params, setParam, resetParams } = useLogisticFilters()
  const role = userStore.user?.role as UserRole
  const [modal, setModal] = React.useState<ModalState>(ModalState.None)
  const [selectedRow, setSelectedRow] = React.useState<LogisticShortObject>()
  const [fetch, fetchState] = logisticApi.useLazyGetNewLogisticCartsQuery()
  logisticApi.useGetProjectsQuery()

  React.useEffect(() => {
    fetch(params)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.offset])

  const onSubmit = () => {
    fetch(params)
    setSelectedRow(undefined)
  }
  const reset = () => {
    resetParams()
    fetch(params)
    setSelectedRow(undefined)
  }

  const openModal = () => {
    setModal(ModalState.Create)
    document.body.style.overflow = 'hidden'
    // window.location.replace('/new/create')
  }

  const closeModal = () => {
    setModal(ModalState.None)
    document.body.style.overflow = 'auto'
  }

  return (
    <>
      {[UserRole.ControllerUKC, UserRole.Author].includes(role) && (
        <AppLayout
          linksRight={[
            {
              title: 'Создать',
              icon: <UserCircleAddIcon />,
              onClick: openModal,
            },
          ]}
        />
      )}
      <AppLayoutTable
        title="Новые заявки"
        header={<Filters onSubmit={onSubmit} reset={reset} />}
        statistics={<Statistics />}
        sidebar={
          selectedRow ? (
            <Details
              key={selectedRow.id}
              data={selectedRow}
              onClose={() => setSelectedRow(undefined)}
            />
          ) : (
            <EmptyDetails />
          )
        }
      >
        {fetchState.isLoading && <AppLoader />}
        {fetchState.data && fetchState.isSuccess && (
          <>
            <AppTable
              loading={fetchState.isFetching}
              dataSource={fetchState.data.results}
              onClickRow={v => setSelectedRow(v)}
              selected={{
                value: selectedRow?.id,
                key: 'id',
              }}
              headers={[
                {
                  data: 'ID Карты',
                  key: 'barcode',
                  width: 50,
                },
                {
                  data: 'Дата',
                  key: 'emboss_date',
                  render: (_, data) => {
                    if (data.emboss_date) {
                      return format(
                        new Date(data.emboss_date),
                        'yyyy-MM-dd HH:mm',
                      )
                    }
                  },
                  width: 50,
                },
                {
                  data: 'Ф.И.О.',
                  key: 'client_full_name',
                  width: 50,
                },
                {
                  data: 'Адрес доставки',
                  key: 'address',
                  width: 50,
                },
                {
                  data: 'Статус',
                  key: 'status',
                  render: (_, item) =>
                    item.status ? LOGISTIC_STATUS_TEXT[item.status] : '-',
                  width: 50,
                },
                {
                  data: 'Тип карты',
                  key: 'card_type',
                  width: 50,
                },
              ]}
            />

            <AppPagination
              forcePage={params.offset! / params.limit!}
              onPageChange={nextPage => {
                setParam('offset', String((nextPage - 1) * params.limit!))
              }}
              count={fetchState.data.count / params.limit!}
            />
          </>
        )}
      </AppLayoutTable>

      {modal === ModalState.Create && (
        <CreateLogisticModal onClose={closeModal} />
      )}
    </>
  )
}
